import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

const Testimonial = ({
  testimonial,
  author,
  designation,
  company,
  textColor = "black",
  opacity,
}) => {
  return (
    <Box
      sx={{
        color: textColor,
        width: "100%",
        opacity: opacity,
        transition: "opacity 1s ease-in-out",
        cursor: "pointer",
      }}
    >
      <h1
        style={{ fontSize: "1.25rem", fontWeight: "100", textAlign: "center" }}
      >
        " {testimonial} "
      </h1>
      <p
        style={{
          fontSize: "0.75rem",
          fontWeight: "100",
          textAlign: "end",
          marginTop: "2rem",
        }}
      >
        — {author}, {designation}, {company}
      </p>
    </Box>
  );
};

const Testimonials = ({ testimonials, interval, textColor }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    let intervalId;

    if (!isHovered) {
      intervalId = setInterval(() => {
        setOpacity(0);
        setTimeout(() => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
          setOpacity(1);
        }, 1000);
      }, interval);
    }

    return () => clearInterval(intervalId);
  }, [testimonials.length, interval, isHovered]);

  return (
    <Box
      sx={{ marginTop: "2.5rem" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Testimonial
        testimonial={testimonials[currentIndex].testimonial}
        author={testimonials[currentIndex].author}
        designation={testimonials[currentIndex].designation}
        company={testimonials[currentIndex].company}
        textColor={textColor}
        opacity={opacity}
      />
    </Box>
  );
};

export default Testimonials;
